import { setHours, setMinutes, setSeconds } from "date-fns";
import * as Llamadas from "./Llamadas";
import tt from "@tomtom-international/web-sdk-services";
import { polygon, booleanPointInPolygon, point } from "@turf/turf";

/*
    function ocultarInputOrigen(){
      if(!spinnerOrigenActivado){
        setOcultarListaOrigen(true);
      }
    }
    */
//Version para nested
export function filtrarAreasPorCoordenadas(areas, lat, long) {
  let listaAreas = [];
  for (let area of areas) {
    let poli = area.coordenadas.split(";");
    let poliTransformado = [];
    poli.forEach((punto) => {
      poliTransformado.push([
        parseFloat(punto.split(",")[0]),
        parseFloat(punto.split(",")[1]),
      ]);
    });
    poliTransformado.push([
      parseFloat(poli[0].split(",")[0]),
      parseFloat(poli[0].split(",")[1]),
    ]);
    //logger([poliTransformado])
    let poligon = polygon([poliTransformado]);
    let punto = point([parseFloat(long), parseFloat(lat)]);
    //logger(point)
    if (booleanPointInPolygon(punto, poligon)) {
      listaAreas.push(area);
    }
  }
  return listaAreas.sort((a, b) => a.prioridad - b.prioridad);
}

function esFechaMenorRango(date1, date2, hours = 0, minutes = 0) {
  const toleranceMs = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);
  const diffMs = Math.abs(date1.getTime() - date2.getTime());
  return diffMs <= toleranceMs;
}

function esFechaMayorRango(date1, date2, hours = 0, minutes = 0) {
  const toleranceMs = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);
  const diffMs = Math.abs(date1.getTime() - date2.getTime());
  return diffMs >= toleranceMs;
}

export async function filtrarTarifasPorDestino(origenParam, destino) {
  let lista = [];
  let tarifasValidas = [];

  if (origenParam && destino) {
    if (origenParam.tarifas) {
      for await (let tarifa of origenParam.tarifas) {
        //Filtrar tarifas por destino
        if (destino.type == "coord") {
          let listaOrdenada = tarifa.areasConPrecios.sort(
            (a, b) => a.prioridad - b.prioridad
          );
          for await (let area of listaOrdenada) {
            let poli = area.coordenadas.split(";").map((item) => item.trim());
            let poliTransformado = [];
            poli.forEach((punto) => {
              let sepa = punto.split(",").map((item) => item.trim());
              poliTransformado.push([parseFloat(sepa[0]), parseFloat(sepa[1])]);
            });
            let poliSepa = poli[0].split(",").map((item) => item.trim());
            poliTransformado.push([
              parseFloat(poliSepa[0]),
              parseFloat(poliSepa[1]),
            ]);
            //Utils.logger([poliTransformado])
            const poligon = polygon([poliTransformado]);
            let sepaLocal = destino.location
              .split(",")
              .map((item) => item.trim());
            const punto = point([
              parseFloat(sepaLocal[0]),
              parseFloat(sepaLocal[1]),
            ]);

            if (booleanPointInPolygon(punto, poligon)) {
              let valida = true;
              //Comprobar km minimos
              if (tarifa.checkPrecioPorKilometros) {
                let resultadoKm = await Utils.calcularRutaCoordenadas(
                  origenParam.coordenadas,
                  destino.location
                );
                if (resultadoKm.distancia < tarifa.kmMinimos * 1000) {
                  valida = false;
                }
              }

              if (valida) {
                let fecha = {
                  start: Utils.convertUTCToLocalTime(tarifa.fechaInicioTarifa),
                  end: Utils.convertUTCToLocalTime(tarifa.fechaFinTarifa),
                };
                let hoy = Utils.getFechaMinimaPlazo(
                  origenParam?.horasDePlazo,
                  origenParam?.minutosDePlazo
                );
                if (
                  hoy.getTime() >= fecha.start.getTime() &&
                  hoy.getTime() <= fecha.end.getTime()
                ) {
                  let fechaNueva = { start: hoy, end: fecha.end };
                  fecha = fechaNueva;
                }
                lista.push(fecha);
                tarifasValidas.push(tarifa);
              }
            }
          }
        } else if (destino.type == "location") {
          tarifa.localizacionesConPrecios.forEach((local) => {
            if (local.key == destino.key) {
              let fecha = {
                start: Utils.convertUTCToLocalTime(tarifa.fechaInicioTarifa),
                end: Utils.convertUTCToLocalTime(tarifa.fechaFinTarifa),
              };
              let hoy = Utils.getFechaMinimaPlazo(
                origenParam?.horasDePlazo,
                origenParam?.minutosDePlazo
              );
              if (
                hoy.getTime() >= fecha.start.getTime() &&
                hoy.getTime() <= fecha.end.getTime()
              ) {
                let fechaNueva = { start: hoy, end: fecha.end };
                fecha = fechaNueva;
              }
              lista.push(fecha);
              tarifasValidas.push(tarifa);
            }
          });
        }
      }
    }
  }

  return { lista, tarifasValidas };
}

export async function tomtomGeometricSearch(languageId, texto, listaPoligonos) {
  let clave = await Llamadas.getApiKeyTomTom();
  let opciones = {
    key: clave,
    language: languageId,
    query: texto,
    idxSet: "POI,Addr,PAD,Str,Xstr",
    geometryList: listaPoligonos,
  };

  logger("opciones tomtom");
  logger(opciones);

  //Descomentar para ver el geojson en consola
  logger("geojson");
  logger(transformarGeojson(opciones.geometryList));

  let results = await tt.services.geometrySearch(opciones).catch((e) => {
    console.error("Geocoder failed due to:");
    console.error(e);
  });

  logger(results);

    const excludeCategories = [
      "airport",
      "harbor",
      "railway station",
      "bus station",
      "ferry terminal",
      "rent-a-car-parking",
      "police station",
      "car parking area",
      "open parking area",
      "rent-a-car facility",
      "sports center",
      "jewelry",
      "shop",
      "important tourist attraction"
    ];

  return results.results;
}

export async function tomTomGetPlaceById(placeId) {
  let clave = await Llamadas.getApiKeyTomTom();
  let results = await tt.services
    .placeById({
      entityId: placeId,
      key: clave,
    })
    .catch((e) => console.error("Geocoder failed due to: " + e));

  logger(results);

  return results.results;
}

//recoger click original y añadir nuestro para abrir y cerrar
export function clickCalendario(e, calendario) {
  e.preventDefault();
  logger("calendario");
  logger(calendario);
  //logger("funcionCalendarioClick");
  //logger(funcClick);
  let abierto = calendario?.current?.isCalendarOpen();
  logger(abierto);
  calendario?.current?.setOpen(!abierto);
  //funcClick();
}

export function isMismoDia(fecha1, fecha2) {
  return (
    fecha1.getDate() == fecha2.getDate() &&
    fecha1.getMonth() == fecha2.getMonth() &&
    fecha1.getYear() == fecha2.getYear()
  );
}

export function redondearFecha(fecha){
  let redondeo = 1000 * 60 * 5;
  let fechaRedondeada = new Date(
    Math.ceil(fecha.getTime() / redondeo) * redondeo
  );
  return fechaRedondeada;
}

export function getFechaMinimaPlazo(horas, minutos) {
  if (!horas) {
    horas = 0;
  }
  if (!minutos) {
    minutos = 0;
  }
  var hoy = new Date();

  var horasSuma = horas * 60 * 60000;
  var minutosSuma = minutos * 60000;
  hoy.setTime(hoy.getTime() + horasSuma + minutosSuma);
  logger("plazo");
  logger(hoy);
  logger("horas: " + horas);
  logger("minutos: " + minutos);
  return hoy;
}

//Calcular distancia entre dos puntos
export async function calcularRutaCoordenadas(coordOrigen, coordDest) {
  if (coordOrigen === "" || coordDest === "") {
    return;
  }
  var res;

  // eslint-disable-next-line no-undef
  var parsedLocations = coordOrigen + ":" + coordDest;

  var clave = await Llamadas.getApiKeyTomTom();
  var opciones = {
    key: clave,
    locations: parsedLocations,
  };
  var results = await tt.services
    .calculateRoute(opciones)
    .catch((e) => console.error("Route Geocoder failed due to: " + e));

  logger(results);
  var resultado = results.toGeoJson();
  logger(resultado);
  if (resultado.features.length > 0) {
    res = {
      distancia: resultado.features[0].properties.summary.lengthInMeters,
      tiempo: resultado.features[0].properties.summary.travelTimeInSeconds,
    };
  }

  return res;
}

export function convertUTCToLocalTime(dateString) {
  let date = new Date(dateString);
  const milliseconds = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  );
  const localTime = new Date(milliseconds);
  return localTime;
}

export function transformarGeojson(lista) {
  var res = {
    type: "FeatureCollection",
    features: [],
  };
  var listaNueva = [];
  lista.forEach((feature) => {
    var elem = {
      type: "Feature",
      properties: {},
      geometry: {
        coordinates: [],
        type: "Polygon",
      },
    };
    var vertices = [];
    feature.vertices.forEach((ver) => {
      var nuevo = ver.split(",");
      var nuevolista = [];
      nuevolista.push(parseFloat(nuevo[0]));
      nuevolista.push(parseFloat(nuevo[1]));
      vertices.push(nuevolista);
    });
    elem.geometry.coordinates.push(vertices);
    listaNueva.push(elem);
  });
  res.features = listaNueva;
  return res;
}

export function ajustarHora(fecha, horas, minutos) {
  return setHours(setMinutes(setSeconds(fecha, 0), minutos), horas);
}

export function getMaxMinPasajeros(tarifasValidasParam, fecha) {
  let min = Infinity;
  let max = 0;

  //pasajeros
  tarifasValidasParam.forEach((tarifa) => {
    if (
      fecha.getTime() >=
        convertUTCToLocalTime(tarifa.fechaInicioTarifa).getTime() &&
      fecha.getTime() <= convertUTCToLocalTime(tarifa.fechaFinTarifa).getTime()
    ) {
      logger(tarifa);
      if (tarifa.maximoPersonas >= max) {
        max = tarifa.maximoPersonas;
      }
      if (tarifa.minimoPersonas <= min) {
        min = tarifa.minimoPersonas;
      }
    }
  });

  if (min == Infinity) {
    min = 1;
  }

  return { maxPersonas: max, minPersonas: min };
}

export function logger(param) {
  if (!process.env.REACT_APP_PRO) {
    console.log(param);
  }
}

export function eliminarAcentos(cadena) {
  if (cadena) {
    return cadena.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  } else {
    return "";
  }
}

export async function getFiltradoTomtomNuevo(texto, listaPoligonos, idioma) {
  let clave = await Llamadas.getApiKeyTomTom();
  let opciones = {
    key: clave,
    language: idioma,
    query: texto,
    idxSet: "POI,Addr,PAD,Str,Xstr",
    geometryList: listaPoligonos,
  };

  logger("opciones tomtom");
  logger(opciones);

  //Descomentar para ver el geojson en consola
  logger("geojson");
  //logger(Utils.transformarGeojson(opciones.geometryList));

  let fuzz = await tt.services.fuzzySearch({
    key: clave,
    language: idioma,
    query: texto,
    idxSet: "POI,Addr,PAD,Str,Xstr",
    countrySet: "ES",
    limit: 50,
  });

  logger(fuzz);

  let listaFuzz = [];
  fuzz?.results.forEach((item) => {
    listaFuzz.push(reemplazarLngPorLon(item));
  });

  let info = {
    poiList: listaFuzz,
    geometryList: listaPoligonos,
  };
  logger(info);
  var filtrado = await getFiltradoTomtom(info);
  return filtrado;
}

function reemplazarLngPorLon(obj) {
  if (Array.isArray(obj)) {
    return obj.map(reemplazarLngPorLon);
  } else if (obj !== null && typeof obj === "object") {
    return Object.keys(obj).reduce((nuevoObj, key) => {
      const nuevoKey = key === "lng" ? "lon" : key;
      nuevoObj[nuevoKey] = reemplazarLngPorLon(obj[key]);
      return nuevoObj;
    }, {});
  } else {
    return obj;
  }
}

export async function getFiltradoTomtom(info) {
  let url =
    "https://api.tomtom.com/search/2/geometryFilter.json?key=ZgA5BHGxv9qOmoXxFaY8HjEgdcNBteVE";
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(info),
    });

    const responseData = await response.json();

    if (response.ok) {
      logger("filtrado tomtom:", responseData);
      return responseData;
    } else {
      throw new Error("Error al obtener el token ");
    }
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export function parsearResultadosTomtom(results) {
  let lista = [];
  const excludeCategories = [
    "airport",
    "harbor",
    "railway station",
    "bus station",
    "ferry terminal",
    "rent-a-car-parking",
    "police station",
    "car parking area",
    "open parking area",
    "rent-a-car facility",
    "sports center",
    "jewelry",
    "shop",
    "important tourist attraction"
  ];
 
  results.forEach((prediction) => {
    //const li = document.createElement("li");
    let coor = "";
    let nuevo = {
      poi: false,
      nombrePOI: "",
      place_id: prediction.id,
      nombre: prediction.address.freeformAddress,
      location: prediction.position.lon + "," + prediction.position.lat,
      coordenadas: prediction.position.lon + "," + prediction.position.lat,
      lat: prediction.position.lat,
      lon: prediction.position.lon,
      type: "coord",
    };

   if (
     prediction.type === "POI" &&
     prediction.poi &&
     prediction.poi.categories &&
      !prediction.poi.categories.some(cat => excludeCategories.includes(cat))
   ) {


      nuevo = {
        poi: true,
        coordenadas: prediction.position.lon + "," + prediction.position.lat,
        lat: prediction.position.lat,
        lon: prediction.position.lon,
        nombrePOI: prediction.poi.name,
        place_id: prediction.id,
        nombre:
          prediction.poi.name + " - " + prediction.address.freeformAddress,
        location: prediction.position.lon + "," + prediction.position.lat,
        type: "coord",
        tipoDestino: "tomtom",
      };

    }


      if (!nuevo.nombre.toLowerCase().includes("aeropuerto")) {
       lista.push(nuevo);
      }




    //Utils.logger(listaDinamica);
    //li.appendChild(document.createTextNode(" description: "+ nuevo.description +""));
    //document.getElementById("results").appendChild(li);
  });
  return lista;
}

// Export all functions as part of the Utils object
const Utils = {
  tomtomGeometricSearch,
  tomTomGetPlaceById,
  clickCalendario,
  isMismoDia,
  getFechaMinimaPlazo,
  calcularRutaCoordenadas,
  convertUTCToLocalTime,
  transformarGeojson,
  ajustarHora,
  getMaxMinPasajeros,
  logger,
  eliminarAcentos,
  getFiltradoTomtomNuevo,
  parsearResultadosTomtom,
  filtrarAreasPorCoordenadas,
  redondearFecha
};

export default Utils;
